import type { JSX } from "solid-js";

/** A click the browser should have: a new tab, a new window, a download. */
export const forBrowser = (e: MouseEvent): boolean => e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey;

/** An in-app link: a real href (open in a new tab works), navigated without a reload. */
export function Link(props: { go: (p: string) => void; to: string; class?: string; children: JSX.Element }) {
  return (
    <a
      href={props.to}
      class={props.class}
      onClick={(e) => {
        if (forBrowser(e)) return;
        e.preventDefault();
        props.go(props.to);
      }}
    >
      {props.children}
    </a>
  );
}
